<script>
import each from 'lodash/each';
import mixins from 'viralstyle-ui/src/vueMixins';
import { mapState } from 'vuex';

export default {
  mixins: [mixins],
  data: () => ({
    isMounted: false,
    height: 0,
    open: false,
    overflowing: false,
    displayShowAllToggle: true,
    heightInit: false,
  }),
  computed: {
    ...mapState(['collections', 'domainConfig']),
    ...mapState({
      collection: state => state.collection.info,
    }),
    collectionLinkCount() {
      return this.isMounted ? document.querySelectorAll('.collection-link').length : 0;
    },
    collectionLinkCollapsedCount() {
      return this.isMounted ? document.querySelectorAll('.collection-link--collapsed').length : 0;
    },
    visible() {
      return this.heightInit ? ['home', 'products', 'collection'].includes(this.$route.name) : true;
    },
    noCollectionImage() {
      return !this.domainConfig.assets.banner && this.collection && !this.collection.banner_url && this.visible;
    },
  },
  mounted() {
    this.height = `${this.$refs.seeAll.clientHeight}px`;

    this.heightInit = true;

    // need this for any hard reloads or first time loads
    setTimeout(() => {
      this.$_setTabIndexes();

      this.isMounted = true;

      this.displayShowAllToggle = !!this.collectionLinkCollapsedCount;
    }, 100);
  },
  methods: {
    $_setTabIndexes() {
      each(this.$refs.collectionLinks, child => {
        let $el = child.$el;

        if (this.open) {
          $el.setAttribute('tabindex', 0);
        } else {
          $el.setAttribute('tabindex', $el.offsetTop > 0 ? -1 : 0);
        }

        if ($el.offsetTop > 0) {
          $el.classList.add('collection-link--collapsed');
        }
      });
    },
    toggleMenu() {
      this.open = !this.open;

      this.height = `${this.open ? this.$refs.container.scrollHeight : this.$refs.seeAll.clientHeight}px`;

      this.$_setTabIndexes();

      //- TODO:
      // if (this.elementOutOfViewport(headerEl).bottom) {
      //   headerEl.style.height = `${(window.innerHeight || document.documentElement.clientHeight) - headerEl.getBoundingClientRect().top}px`;
      // }
    },
    seeAllTabNext(e) {
      if (this.open) {
        e.preventDefault();

        document.querySelector('.collection-link--collapsed').focus();
      }
    },
    seeAllTabPrev(e) {
      e.preventDefault();

      document.querySelectorAll('.collection-link')[this.collectionLinkCount - this.collectionLinkCollapsedCount - 1].focus();
    },
    collectionLinkTabNext(e, index) {
      if (index === this.collectionLinkCount - this.collectionLinkCollapsedCount - 1) {
        e.preventDefault();

        document.querySelector('.collection-link--see-all').focus();
      }

      if (index === this.collectionLinkCount - 1) {
        e.preventDefault();

        let firstProductEl = document.querySelector('.product-group-product');

        if (firstProductEl) {
          firstProductEl.focus();
        } else {
          document.querySelector('.footer-link').focus();
        }

        if (this.open) {
          this.toggleMenu();
        }
      }
    },
    collectionLinkTabPrev(e, index) {
      if (index === this.collectionLinkCount - this.collectionLinkCollapsedCount) {
        e.preventDefault();

        document.querySelector('.collection-link--see-all').focus();
      }
    },
  },
};
</script>

<template lang='pug'>
.z-10.w-full.transition-250.transition-height.hidden.md_block(
  ref='container',
  :class='[overflowing ? "overflow-auto" : "overflow-hidden", noCollectionImage ? "relative" : "absolute"]',
  :style='{ height: visible ? height : 0 }',
)
  .bg-gray-900.opacity-75.absolute.h-full.w-full.top-0.left-0
  .container.mx-auto.text-gray-400.relative.z-1.items-start.flex.text-sm(v-show='visible')
    .w-10-12.flex.flex-wrap(:class='{ "justify-between": collectionLinkCollapsedCount }',)
      router-link.px-1.py-1_5.hover_underline.cursor-pointer.select-none.collection-link(
        ref='collectionLinks',
        v-for='(collection, index) in collections',
        :key='`${collection.name}${collection.slug}`',
        :to='{ name: "collection", params: { collectionSlug: collection.slug, publicName: domainConfig.public_name, page: "1" } }',
        @keydown.native.tab.exact='collectionLinkTabNext($event, index)',
        @keydown.native.shift.tab.exact='collectionLinkTabPrev($event, index)',
      ) {{collection.name}}
    .w-2-12.flex.items-center.justify-end(v-show='displayShowAllToggle')
      a.tracking-wider.font-bold.leading-none.flex.items-center.px-1.py-1_5.hover_underline.cursor-pointer.select-none.collection-link--see-all(
        tabindex='0',
        ref='seeAll',
        :aria-expanded='open ? "true" : "false"',
        @click='toggleMenu',
        @keyup.enter='toggleMenu',
        @keydown.tab.exact='seeAllTabNext',
        @keydown.shift.tab.exact='seeAllTabPrev',
      )
        span SEE ALL
        svg.h-1.w-1.inline(viewBox='0 0 24 24')
          path.fill-current(v-if='open', d='M19,13H5V11H19V13Z')
          path.fill-current(v-else, d='M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z')
</template>

<style>
@import '~import/index';

.collection-link.router-link-exact-active {
  text-decoration: underline;
}
</style>